module.exports = __webpack_public_path__ + "static/index/img/baikal-405.eb05157e.jpg";